module.exports = __webpack_public_path__ + "static/img/4.af3d1a2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/4.png
// module id = iQvB
// module chunks = 0